// removed by extract-text-webpack-plugin
module.exports = {"footerText":"_30V58J4_-txLtoxb4QnVKE","footerLogo":"x5QJs24f9CYQxc6YDKhgG"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/AppCore/Component/assets/component.css
// module id = 891
// module chunks = 0